<template class="modal-cancel-leftovers">
<b-modal id="server-error-modal" centered :hide-footer="true" :hide-header="true">
  <template v-slot:default="{ hide }">
    <p class="modal-title">Something Went Wrong</p>
  </template>

  <img class="error-image" src="@assets/images/icon-error.svg" />

  <div class="modal-text" v-if="err">
    <p>
      {{ err ? err.msg : '' }}
      <br />
      {{ err && err.retry && err.retry.enabled && !err.support ? err.msg2 : '' }}
    </p>
  </div>

  <template v-slot:modal-footer="{ contactSupport, retry }">
    <div class="modal-actions-wrapper">
      <BaseButton class="btn" @click="close()" v-if="err && err.close && !err.retry.enabled && !err.support">
        Close
      </BaseButton>
      <BaseButton class="btn" @click="onRetry()" v-if="err && err.retry && err.retry.enabled && !err.support">
        Retry
      </BaseButton>
      <BaseButton class="btn-ghost" @click="contactSupport()" v-if="err && err.support">
        Contact Support
      </BaseButton>
    </div>
  </template>
</b-modal>
</template>

<script>
import { authComputed, errorsComputed, errorsMethods } from '@state/helpers';

export default {
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {
    ...authComputed,
    ...errorsComputed,
    err() {
      if (this.serverError) {
        return this.serverError;
      }
    },
  },
  methods: {
    ...errorsMethods,
    close() {
      this.$bvModal.hide('server-error-modal');
    },
    onRetry() {
      this.$bvModal.hide('server-error-modal');
      this.trackManualRetry();
      this.setRetry({ retry: this.serverError.retry });
    },
    contactSupport() {
      const helpUrl = this.currentUser.client.helpBaseUrl;
      window.localStorage.removeItem('manualRetry');

      if (helpUrl !== '') {
        window.location.href = helpUrl.includes('@') ? `mailto:${helpUrl}` : helpUrl;
      }
    },
    getManualRetryCount() {
      return JSON.parse(window.localStorage.getItem('manualRetry'));
    },
    trackManualRetry() {
      let manualRetryCount = this.getManualRetryCount();

      if (!manualRetryCount) {
        window.localStorage.setItem('errorsShown', (manualRetryCount += 1));
      }
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-backdrop {
  background-color: white !important;
  opacity: 0.8 !important;
}

.modal-title {
  font-size: 1.7rem;
  font-weight: 600 !important;
  margin-bottom: 3rem !important;
}

.modal-body {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.error-image {
  margin-bottom: 3rem;
}

.modal-text {
  font-weight: 400;
  margin-bottom: 3rem;
  text-align: center;
}

.modal-actions-wrapper {
  display: flex;
  flex-direction: row !important;
  justify-content: space-around;
  padding: 0 !important;

  .button.btn-ghost {
    color: $color-action !important;
    font-weight: 400;
    text-transform: capitalize !important;
  }

  .btn-danger {
    background-color: $color-cancel-leftovers-modal-btn-bg;
    border-color: $color-cancel-leftovers-modal-btn-bg;
    border-radius: $base-border-radius;
    font-size: 1.7rem;
  }
}
</style>
